import React from 'react';
import moment from 'moment';
import Button from '~/components/button';
import Collapse from '~/components/collapse';
import ContainerFlex from '~/components/containerFlex';
import Grid from '~/components/grid';
import Input, { MaskTypes } from '~/components/input';
import * as St from '~/views/Consult/User/Detail/styles';
import CardSection from './CardSection';

interface FinancialSectionProps {
  form: Record<string, any>;
  dataBankingDataLoan: any;
  onOpenWalletCards: () => void;
  onOpenBlackListCards: () => void;
  onOpenLoanSection: () => void;
  onOpenKycHistory: () => void;
  onOpenLoanHistory: () => void;
  tiposProdutosCartao: string[];
  productTab?: string;
  cards: any[];
  onTabChange: (product: string) => void;
  onOpenCardDropdown: () => void;
  callbackUpdateInvoiceExpiration: () => Promise<void>;
  callbackClickDuplicateCard: () => Promise<void>;
  callbackBlockCard: () => Promise<void>;
}

const FinancialSection: React.FC<FinancialSectionProps> = ({
  form,
  dataBankingDataLoan,
  onOpenWalletCards,
  onOpenBlackListCards,
  onOpenLoanSection,
  onOpenKycHistory,
  onOpenLoanHistory,
  tiposProdutosCartao,
  productTab,
  cards,
  onTabChange,
  onOpenCardDropdown,
  callbackUpdateInvoiceExpiration,
  callbackClickDuplicateCard,
  callbackBlockCard,
}) => {
  return (
    <>
      {form.temCarteiraDigital && (
        <Collapse collapseHeight={40} title="4. Carteira digital">
          <ContainerFlex marginLeft={26} marginRight={26}>
            <Grid xs={1} lg={2} gap={30}>
              <Input
                label="Data adesão"
                value={
                  form?.carteira?.dataAdesao?.length
                    ? moment(form?.carteira?.dataAdesao).format('DD/MM/YYYY')
                    : ''
                }
                placeholder="DD/MM/YYYY"
                maxLength={10}
                mask={MaskTypes.DATE}
                readOnly
              />
              <ContainerFlex style={{ maxHeight: '52px' }} row align="center">
                <Input
                  label="Quantidade de cartões cadastrados"
                  value={form?.carteira?.cartoes?.length}
                  readOnly
                />
                <Button
                  style={{ width: 280, height: 37, marginLeft: 10 }}
                  onClick={onOpenWalletCards}
                  disabled={!form?.carteira?.cartoes?.length}
                >
                  Ver cartões
                </Button>
              </ContainerFlex>
              <Input
                label="Data primeira compra"
                value={
                  form?.carteira?.dataPrimeiraCompra?.length
                    ? moment(form?.carteira?.dataPrimeiraCompra).format(
                        'DD/MM/YYYY',
                      )
                    : ''
                }
                placeholder="DD/MM/YYYY"
                maxLength={10}
                mask={MaskTypes.DATE}
                readOnly
              />
              <Input
                label="Operador de Venda"
                value={
                  form.carteira.nomeOperador ? form.carteira.nomeOperador : ''
                }
                readOnly
              />
            </Grid>
            <ContainerFlex align="flex-end">
              <Button
                style={{ width: 280, height: 37, marginTop: 20 }}
                onClick={onOpenBlackListCards}
                disabled={
                  !form?.carteira?.cartoes?.some((item) => item.blackList)
                }
              >
                Remover blackList
              </Button>
            </ContainerFlex>
          </ContainerFlex>
        </Collapse>
      )}

      <CardSection
        form={form}
        tiposProdutosCartao={tiposProdutosCartao}
        productTab={productTab}
        cards={cards}
        onTabChange={onTabChange}
        onOpenCardDropdown={onOpenCardDropdown}
        callbackUpdateInvoiceExpiration={callbackUpdateInvoiceExpiration}
        callbackClickDuplicateCard={callbackClickDuplicateCard}
        callbackBlockCard={callbackBlockCard}
      />

      <Collapse
        collapseHeight={60}
        title={form.temCarteiraDigital ? '6. Empréstimo' : '5. Empréstimo'}
        initialState="close"
        actionOnOpen={onOpenLoanSection}
      >
        <ContainerFlex marginLeft={26} marginRight={26}>
          {dataBankingDataLoan ? (
            <ContainerFlex>
              <ContainerFlex marginTop={30}>
                <Grid xs={1} lg={2} gap={30}>
                  <ContainerFlex>
                    <Input
                      label="Instituição de pagamento"
                      readOnly
                      value={`${
                        dataBankingDataLoan?.codigoBanco
                          ? dataBankingDataLoan?.codigoBanco
                          : '-'
                      } - ${
                        dataBankingDataLoan?.nomeBanco
                          ? dataBankingDataLoan?.nomeBanco
                          : '-'
                      }`}
                    />
                    <ContainerFlex row gap="10">
                      <Input
                        label="Agência"
                        readOnly
                        value={
                          dataBankingDataLoan?.agencia
                            ? dataBankingDataLoan?.agencia
                            : '-'
                        }
                      />
                      <Input
                        label="Conta - DV"
                        readOnly
                        value={`${
                          dataBankingDataLoan?.contaSemDigito
                            ? dataBankingDataLoan?.contaSemDigito
                            : '-'
                        }-${
                          dataBankingDataLoan?.contaDigito
                            ? dataBankingDataLoan?.contaDigito
                            : '-'
                        }`}
                      />
                    </ContainerFlex>
                  </ContainerFlex>
                  <ContainerFlex>
                    <ContainerFlex row gap="10">
                      <Input
                        label="Tipo de conta"
                        readOnly
                        value={
                          dataBankingDataLoan?.tipoConta
                            ? dataBankingDataLoan?.tipoConta
                            : '-'
                        }
                      />
                      <Input
                        label="Data Inclusão"
                        readOnly
                        value={
                          dataBankingDataLoan?.dataCadastro
                            ? moment(dataBankingDataLoan?.dataCadastro).format(
                                'DD/MM/YYYY',
                              )
                            : '-'
                        }
                      />
                    </ContainerFlex>
                    <ContainerFlex row gap="10">
                      <Input
                        label="Tipo chave pix"
                        readOnly
                        value={
                          dataBankingDataLoan?.tipoChavePix
                            ? dataBankingDataLoan?.tipoChavePix
                            : '-'
                        }
                      />
                      <Input
                        label="Chave pix"
                        readOnly
                        value={
                          dataBankingDataLoan?.chavePix
                            ? dataBankingDataLoan?.chavePix
                            : '-'
                        }
                      />
                    </ContainerFlex>
                  </ContainerFlex>
                </Grid>
              </ContainerFlex>
            </ContainerFlex>
          ) : (
            <ContainerFlex center marginTop={30}>
              <St.TitleCategory style={{ paddingLeft: 0, marginRight: 0 }}>
                Não possui dados bancários para empréstimos.
              </St.TitleCategory>
            </ContainerFlex>
          )}
          <ContainerFlex marginTop={50}>
            <ContainerFlex row end>
              <Button
                style={{ width: '229px' }}
                marginLeft={16}
                onClick={onOpenKycHistory}
              >
                KYC
              </Button>
              <Button marginLeft={40} onClick={onOpenLoanHistory}>
                Histórico Celcoin
              </Button>
            </ContainerFlex>
          </ContainerFlex>
        </ContainerFlex>
      </Collapse>

      <Collapse
        collapseHeight={40}
        title={
          form.temCarteiraDigital ? '7. Classificação' : '6. Classificação'
        }
      >
        <ContainerFlex marginLeft={26} marginRight={26}>
          <Grid xs={1} lg={2} gap={30}>
            <Input
              label="Descrição da classificação"
              value={form.nivel}
              readOnly
            />
            <Input
              label="Data da classificação"
              value={
                form.dataCampanha
                  ? moment(form.dataCampanha).format('DD/MM/YYYY')
                  : ''
              }
              readOnly
            />
            <Input label="Pontuação atual" value={form.pontuacao} readOnly />
            <Input
              label="Quantidade de faturas com pagamento total"
              value={form.quantidadeTotalPaga}
              readOnly
            />
            <Input
              label="Quantidade de faturas com pagamento parcial"
              value={form.quantidadeTotalParcial}
              readOnly
            />
            <Input
              label="Quantidade de faturas com pagamento parcelado"
              value={form.quantidadeTotalParcelada}
              readOnly
            />
            <Input
              label="Passagens pela Cobrança"
              value={form.quantidadeCobranca}
              readOnly
            />
            <Input
              label="Data da Reativação"
              value={
                form.dataDecisao.value
                  ? moment(form.dataDecisao.value).format('DD/MM/YYYY')
                  : ''
              }
              readOnly
            />
          </Grid>
        </ContainerFlex>
      </Collapse>
    </>
  );
};

export default FinancialSection;
